module.exports = __webpack_public_path__ + "static/img/loyo-medal-2.b25c68db.png";